import axios from 'axios';

const SA_KEY = 'eg_sa_token';
const UA_KEY = 'eg_token';

// Pick the right localStorage key based on which portal the current page
// belongs to.  Super admin pages sit under /super-admin; everything else
// (coaching admin, teacher, student) uses the shared user token.
function getActiveToken() {
  const isSA = typeof window !== 'undefined' && window.location.pathname.startsWith('/super-admin');
  return localStorage.getItem(isSA ? SA_KEY : UA_KEY) || null;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 180000, // per-request timeouts override this
});

// Attach the correct JWT to every request
api.interceptors.request.use((config) => {
  const token = getActiveToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401, clear both tokens and send back to the right login page
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const is401       = error.response?.status === 401;
    const isLoginCall = error.config?.url?.includes('/auth/login');

    if (is401 && !isLoginCall) {
      localStorage.removeItem(SA_KEY);
      localStorage.removeItem(UA_KEY);
      const isSuperAdminPortal = window.location.pathname.startsWith('/super-admin');
      window.location.href = isSuperAdminPortal ? '/super-admin' : '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
